import Vue from 'vue';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';
// Docs: https://vcalendar.io/attributes.html#attribute-types

import {
  SlotsPicker,
} from '@/components';

import calenderIcon from '@/assets/images/icons/calender.svg';
import editIcon from '@/assets/images/icons/edit.svg';

import {
  mapActions,
  mapGetters,
  mapMutations,
} from 'vuex';

import {
  api,
} from '@/utils';

import router from '@/router';

export default {
  name: 'DateTimePicker',
  components: {
    DatePicker,
    [SlotsPicker.name]: SlotsPicker,
    calenderIcon,
    editIcon,
  },
  props: {
    skipReserve: {
      type: Boolean,
      required: false,
    },
    isUpdate: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMaintenance: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    isOpen: false,
    slotsPickerIsActive: false,
    // Slots from the backend
    slots: [],
    slotHours: [],
    // Selected date in c# format
    selectedDate: null,
    // Month & year to get the slots
    month: 0,
    year: 0,
    // Date where the calender starts
    fromDate: new Date(),
    // Amount of times we try to gets
    tryToGetSlots: 3,
    // These are the pages on the calendar we already visited
    visitedPages: [],
    attributes: [{
      dot: {
        color: 'red',
        class: 'my-dot-class',
      },
      dates: [],
    }],

  }),
  computed: {
    ...mapGetters('appointment', {
      licensePlate: 'getLicensePlate',
      personalData: 'getPersonalData',
      depotId: 'getDepotId',
      vehiculeType: 'getVehiculeType',
      serviceType: 'getServiceType',
      slotNumber: 'getSlotNumber',
      date: 'getDate',
      hour: 'getHour',
      errorSlot: 'getErrorSlot',
      company: 'getCompany',
    }),
    language() {
      return Vue.config.language.replace('_', '-');
    },
    // Model that is bind to date-picker
    datePickerModel: {
      get() {
        return this.selectedDate;
      },
      set(value) {
        this.selectedDate = value;

        if (value !== null) {
          this.openSlotsPicker();
        }
      },
    },
    availableDates() {
      const availableDates = this.slots.map(s => s.dateTime);
      return availableDates;
    },
    availableSlots() {
      const selectedDateLocal = this.$options.filters.formatDateLocal(this.datePickerModel);
      const findAvailableSlots = this.slots
        .find(s => s.dateTime === selectedDateLocal);
      return findAvailableSlots != null ? findAvailableSlots.hours : [];
    },
    datePickerAttributes() {
      return [{
        highlight: {
          color: 'green',
          fillMode: 'none',
        },
        dates: this.availableDates,
      }];
    },
    showDateNotAvailableErrorMessage() {
      return this.selectedDate !== null && this.availableSlots.length === 0;
    },
  },
  methods: {
    ...mapActions('appointment', {
      setSlotNumber: 'SET_SLOTNUMBER',
    }),
    ...mapMutations('appointment', {
      setReservation: 'APPEND_RESERVATION',
    }),
    fetchSlots() {
      const getSlotsRequestModel = {
        depotId: this.depotId,
        customerType: this.vehiculeType,
        appointmentType: this.serviceType,
        month: this.month,
        year: this.year,
        licensePlate: this.licensePlate,
        leaseId: this.personalData.leasingCompanyId,
        company: this.company,
      };

      api.post('/appointment/slots', getSlotsRequestModel)
        .then(response => {
          this.slots = this.slots.concat(response.data);

          // If slots are empty we go to the next page in the datepicker,
          // This triggers changePage runs fetchSlots() again
          if (this.slots.length === 0 && this.tryToGetSlots > 0) {
            this.year = this.month === 12 ? this.year + 1 : this.year;
            this.month = this.month === 12 ? 1 : this.month + 1;
            this.fromDate = new Date(this.year, this.month - 1, 1);
            this.tryToGetSlots -= 1;
          }
        }).catch(() => {
          router.push({
            name: 'error',
          });
        });
    },
    changePage(page) {
      if (this.visitedPages.find(vp => vp.month === page.month && vp.year === page.year) == null) {
        this.month = page.month;
        this.year = page.year;
        this.visitedPages.push(page);
        this.fetchSlots();
      }
    },
    openPopup() {
      if (this.depotId !== 0) {
        this.isOpen = true;
        document.getElementById('app').style.overflow = 'hidden';
      }
    },
    closePopup() {
      this.isOpen = false;
      document.getElementById('app').style.overflow = 'unset';
    },
    openSlotsPicker() {
      if (!this.showDateNotAvailableErrorMessage) {
        this.slotsPickerIsActive = true;
      }
    },
    closeSlotsPicker(availableSlot) {
      if (availableSlot != null) {
        const dateForBackend = this.$options.filters.formatDateBackend(this.selectedDate);

        const reservationRequestModel = {
          licenseplate: this.licensePlate,
          depotId: this.depotId,
          date: dateForBackend,
          hour: availableSlot.hour,
          duration: availableSlot.duration,
          slotNumber: this.slotNumber,
          company: this.company,
        };

        if (this.isMaintenance) {
          reservationRequestModel.maintenance = true;
        }

        if (this.skipReserve) {
          this.slotsPickerIsActive = false;
          const reservation = {
            slotNumber: '123',
            date: reservationRequestModel.date,
            hour: reservationRequestModel.hour,
            duration: reservationRequestModel.duration,
          };
          this.setReservation(reservation);
          this.closePopup();
        } else {
          this.setSlotNumber(reservationRequestModel)
            .then(() => {
              if (!this.errorSlot) {
                this.slotsPickerIsActive = false;
                this.closePopup();
              }
            });
        }
      } else {
        this.slotsPickerIsActive = false;
      }
    },
  },
  watch: {
    depotId: function () {
      this.month = 0;
      this.year = 0;
      this.selectedDate = null;
      this.visitedPages = [];
      this.slots = [];
    },
  },
};
